export default __webpack_public_path__ + "_/images/svg_icons/double-arr-down-0f3b2d2e38af2ad8bec19758b3b103163197196ac99764ba480dc9909c68c22f.svg";